import styled, { css } from 'styled-components';
import { collectPackageInfo } from '../../collectPackageInfo';
collectPackageInfo('Card/CardContent');

/**
 * Компонент для отображения как текстового, так и любого другого контента.
 */
export var CardContent = /*#__PURE__*/styled.div.withConfig({
  componentId: "plasma__sc-x5kd9v-0"
})(["display:flex;flex-direction:column;position:relative;box-sizing:border-box;padding:", "rem 1rem;border-radius:inherit;", " ", ""], function (_ref) {
  var compact = _ref.compact;
  return compact ? 0.375 : 1;
}, function (_ref2) {
  var disabled = _ref2.disabled;
  return disabled && css(["opacity:0.5;"]);
}, function (_ref3) {
  var cover = _ref3.cover,
      _ref3$coverGradient = _ref3.coverGradient,
      coverGradient = _ref3$coverGradient === void 0 ? true : _ref3$coverGradient;
  return cover && css(["position:absolute;top:0;left:0;right:0;bottom:0;justify-content:flex-end;", ";"], coverGradient && css(["background:linear-gradient(180deg,rgba(0,0,0,0) 0%,rgba(0,0,0,0.74) 100%);"]));
});